import React, { Fragment, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Button, FormGroup, Picker, RadioGroup } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';

import Select from '../../common/Select';
import Input from '../../common/maxLengthInput';
import useInput from '../../../leads_component/shared-components/hooks/useBasicInput';
import useSelect from '../../../leads_component/shared-components/hooks/useSelect';

import { useInputMaxCharLengthPlugin } from '../../../leads_component/shared-components/plugins/input-plugins';
import { genBasicHooks } from '../../../leads_component/shared-components/plugins/helper';

const sourceType = {
  Non_Ad: 'Non_Ad',
  Ad: 'Ad',
};

const detailType = {
  Campaign: 'mpCampaignId',
  Ad: 'mpAdId',
};
const Tag = (props) => {
  const { model = 'add', data = {}, tagList, wxAppId } = props || {};

  const {
    ruleId = undefined, // 标签规则ID
    ruleName, // 标签规则名称
    fansSourceType, // 粉丝来源 Non_Ad(非广告渠道)/Ad(广告渠道)
    fansSourceDetail, // 粉丝来源详情 fansSourceType=Ad时有值
    // key 范围字段名 mpCampaignId(微信推广计划ID)/mpAdId(微信广告ID)
    // value 范围字段值
    tagId, // 应用标签ID
  } = data;

  const nameHooks = genBasicHooks(useInput, { value: model == 'edit' ? ruleName : '' }).usePlugin(
    useInputMaxCharLengthPlugin,
    { maxLength: 20 },
  );
  const [selectedType, setType] = useState(model == 'edit' ? fansSourceType : sourceType.Ad);
  const tagSelectHooks = useSelect({ value: model == 'edit' ? tagId : '' });

  const [campaignList, setCampaignList] = useState([]);
  const [adList, setAdList] = useState([]);
  const detailTypeHooks = useSelect({
    value: model == 'edit' ? Object.keys(fansSourceDetail)[0] : detailType.Campaign,
  });

  const [fansSourceValue, setSource] = useState(model == 'edit' ? Object.values(fansSourceDetail)[0] : []);
  const [sourceError, setSourceError] = useState(false);

  useEffect(() => {
    RPCFactory.wechatRuleManagement
      .init(wxAppId, {
        ruleId,
      })
      .done((data) => {
        if (data) {
          setCampaignList(
            data.campaignList.map((item) => ({
              name: item.mpCampaignId,
              describe: item.campaignName,
              disabled: item.occupiedByOtherRules,
            })),
          );
          setAdList(
            data.adgroupList.map((item) => ({
              name: item.mpAdId,
              describe: item.adName,
              disabled: item.occupiedByOtherRules,
            })),
          );
        }
      });
  }, [wxAppId, ruleId]);
  const NewUserItemComponent = (props = {}) => {
    const { type = '', status = 'add', onClick, disabled, data = {} } = props;

    const valueLabel = 'describe';
    if (type === 'user-list') {
      // 左侧的选择结构
      return (
        <li
          className={classNames('feed-item spaui-userpicker-feed-item', {
            checked: status === 'checked',
            disabled: data.occupiedByOtherRules,
          })}
          onClick={onClick}
        >
          <div className="feed-info spaui-userpicker-feed-info">
            <span
              className={`feed-title spaui-userpicker-feed-title ${data.disabled ? 'disabled' : ''}`}
              disabled={data.disabled}
            >
              {data[valueLabel]}
            </span>
            <p className="feed-desc spaui-userpicker-feed-desc"></p>
          </div>

          <span className="feed-action spaui-userpicker-feed-action">
            {status === 'checked' ? <i className="icon icon-checked"></i> : null}
          </span>
        </li>
      );
    }
    if (type === 'selection-list') {
      // 右侧的选中结构
      return (
        <li
          className={classNames('feed-item spaui-userpicker-feed-item', {
            'feed-item-delete spaui-userpicker-feed-item-delete': true,
          })}
        >
          <div className="feed-info spaui-userpicker-feed-info">
            <span className="feed-title spaui-userpicker-feed-title">{data[valueLabel]}</span>
          </div>
          {!disabled ? (
            <span className="feed-action spaui-userpicker-feed-action">
              <Button displayType="link" onClick={onClick}>
                删除
              </Button>
            </span>
          ) : null}
        </li>
      );
    }
    return null;
  };

  const SelectedTipComponent = (props = {}) => {
    const { selectionTitle = '', data = [] } = props;

    return data.length != 0 ? (
      <h3 className="title">
        已选择{data.length} 个{detailTypeHooks.props.value == detailType.Campaign ? '计划' : '广告'}
      </h3>
    ) : (
      <h3 className="title">已选择 0 个{detailTypeHooks.props.value == detailType.Campaign ? '计划' : '广告'}</h3>
    );
  };

  const SearchInputLeftComponent = (props = {}) => (
    <Select
      {...detailTypeHooks.props}
      data={[{ value: detailType.Campaign, label: '推广计划' }, { value: detailType.Ad, label: '广告' }]}
      onChange={(e, value) => {
        detailTypeHooks.props.onChange(e, value);
        setSource([]);
      }}
    />
  );

  const onPickChange = (e, value) => {
    setSource(value);
    setSourceError(false);
  };

  const canSubmit = () => {
    let res = true;

    if (!nameHooks.props.value || nameHooks.props.value.length == 0) {
      res = false;
      nameHooks.setError();
    }

    if (selectedType == sourceType.Ad && fansSourceValue.length == 0) {
      res = false;
      setSourceError(true);
    }

    if (!tagSelectHooks.props.value || tagSelectHooks.props.value == '') {
      res = false;
      tagSelectHooks.setValid(false);
    }

    return res;
  };
  const onSubmit = () => {
    if (model == 'edit') {
      RPCFactory.wechatRuleManagement
        .update(wxAppId, {
          tagId: tagSelectHooks.props.value,
          ruleId,
        })
        .then(() => {
          props.onSubmit();
        })
        .fail((code, msg) => {
          alert(msg);
        });
    } else {
      const valid = canSubmit();

      if (!valid) {
        return;
      }
      RPCFactory.wechatRuleManagement
        .add(wxAppId, {
          ruleName: nameHooks.props.value,
          fansSourceType: selectedType,
          fansSourceDetail:
            selectedType == sourceType.Ad
              ? {
                  [detailTypeHooks.props.value]: fansSourceValue,
                }
              : undefined,
          tagId: tagSelectHooks.props.value,
        })
        .then(() => {
          props.onSubmit();
        })
        .fail((code, msg) => {
          alert(msg);
        });
    }
  };

  const renderPicker = () => (
    <Fragment>
      <Picker
        data={detailTypeHooks.props.value == detailType.Campaign ? campaignList : adList}
        searchFields={['describe']}
        value={fansSourceValue}
        onChange={onPickChange}
        SearchInputLeftComponent={SearchInputLeftComponent}
        searchPlaceholder={detailTypeHooks.props.value == detailType.Campaign ? '搜索推广计划' : '搜索广告'}
        UserItemComponent={NewUserItemComponent}
        SelectedTipComponent={SelectedTipComponent}
        className="store-picker"
        disabled={model == 'edit'}
      />
      {sourceError ? <div className="error-text">请选择渠道</div> : null}
    </Fragment>
  );
  return (
    <div className="tagrule-setting form-list-normal">
      <div className="lump lump-nohd">
        <div className="lump-bd">
          <ul className="infos">
            <li className="infolist">
              <span className="info-tt">规则名称</span>
              <div className="info-des">
                <Input {...nameHooks.props} placeholder="请输入规则名称" disabled={model == 'edit'}></Input>
              </div>
            </li>
            <li className="infolist">
              <span className="info-tt info-tt-read">渠道来源</span>
              <div className="info-des info-des-wide">
                <RadioGroup
                  vertical
                  data={[
                    {
                      value: sourceType.Non_Ad,
                      children: (
                        <span>
                          非广告渠道<span className="radio-tip">(如用户通过扫描二维码/公众号搜索/关注公众号等)</span>
                        </span>
                      ),
                    },
                    {
                      value: sourceType.Ad,
                      children: (
                        <span>
                          广告渠道<span className="radio-tip">(用户点击广告关注落地页)</span>
                        </span>
                      ),
                    },
                  ]}
                  value={selectedType}
                  onChange={(e, value) => {
                    setType(value);
                  }}
                  disabled={model == 'edit'}
                />
                {selectedType == sourceType.Ad ? renderPicker() : null}
              </div>
            </li>
            <li className="infolist">
              <span className="info-tt">粉丝标签</span>
              <div className="info-des">
                <FormGroup>
                  <Select
                    {...tagSelectHooks.props}
                    data={tagList}
                    placeholder="请选择标签"
                    valueFieldName="tagId"
                    labelFieldName="tagName"
                  />
                </FormGroup>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="modal-footer">
        <Button onClick={props.onCancel}>取消</Button>
        <Button bsStyle="primary" onClick={onSubmit}>
          提交
        </Button>
      </div>
    </div>
  );
};

export default Tag;
